<script>
    import { links } from 'svelte-routing';
    import { _ } from 'svelte-i18n';
    export let to;
    export let src;
    export let alt = "";
    export let nolink = false;
</script>

<style>
    a {
        text-decoration: none;
    }

    .info-img {
        max-width: 120px;
        max-height: 120px;
        width: 20vw;
        height: 20vw;
        margin-right: var(--spacingLarge);
        border-radius: 100%;
        object-fit: cover;
    }

    .info-wrap {
        display: flex;
        align-items: center;
        max-width: 400px;
        width: 70vw;
        margin: 0 var(--spacingLarge);
    }

    .info-text {
        max-width: 260px;
    }

    .nolink {
        pointer-events: none;
    }

    .nolink :global.link-name {
        text-decoration: none;
    }

    @media screen and (max-width: 967px) {

        a:not(:first-child) {
            margin-top: var(--spacingLarge);
        }

        a:nth-child(2) .info-wrap {
            flex-direction: row-reverse;
        }

        a:nth-child(2) .info-img {
            margin-right: 0;
            margin-left: var(--spacingLarge);
        }
    }

    @media screen and (max-width: 500px) {
        .info-wrap {
            margin: 0 0;
            width: auto;
        }
    }

</style>

<a {...$$restProps} href={to} target="_blank" on:click use:links class:nolink={nolink}>
    <div class="info-wrap">
        <img {alt} {src} class="info-img" />
        <div class="info-text">
            {nolink ? $_('learn.unlinked_article') : $_('learn.linked_article')}
            <slot />
        </div>
    </div>
</a>